import ko from 'knockout';
import _ from 'lodash';
import Signals from 'signals';
import './panel-header/panel-header';
import '../panel-kpi/kpi-panel';
import '../panel-top-list/top-list-panel';
import '../panel-trend/trend-panel';
import 'components-bootstrap';
import PermissionService from '../../../../services/permission.service';
import PanelOptionsService from '../../dialogs/panel-options/panel-options.service';
import templateMarkup from 'raw-loader!./panel.template.html';
import LoginService from "../../../../services/login.service";

class Panel {
    constructor(params) {
        var self = this;

        var showOptionsSignal = new Signals.Signal();
        var clonePanelSignal = new Signals.Signal();
        var movePanelSignal = new Signals.Signal();
        var copyPanelSignal = new Signals.Signal();
        var copyPanelAdvancedSignal = new Signals.Signal();
        self.dataProvider = params.dataProvider;
        self.dashboardsAndTabsList = params.dashboardsAndTabsList;
        self.selectedTab = params.selectedTab;
        self.viewId = params.viewId;
        self.permissionService = new PermissionService(LoginService.userObject);

        self.panelHeaderSignals = {
            deleteButtonClicked: new Signals.Signal(),
            clonePanelClicked: clonePanelSignal,
            movePanelClicked: movePanelSignal,
            copyPanelClicked: copyPanelSignal,
            copyPanelAdvancedClicked: copyPanelAdvancedSignal,
            optionsButtonClicked: showOptionsSignal
        };

        self.panelHeaderSignals.deleteButtonClicked.add(self.onDeleteButtonClicked.bind(self));
        self.panelHeaderSignals.clonePanelClicked.add(self.onClonePanelClicked.bind(self));
        self.panelHeaderSignals.movePanelClicked.add(self.onMovePanelClicked.bind(self));
        self.panelHeaderSignals.copyPanelClicked.add(self.onCopyPanelClicked.bind(self));
        self.panelHeaderSignals.copyPanelAdvancedClicked.add(self.onCopyPanelAdvancedClicked.bind(self));

        self.showLoadingIconSignal = new Signals.Signal();
        self.showLoadingIconSignal.add(self.onShowLoadingIcon.bind(self));

        self.titleChangedSignal = new Signals.Signal();
        self.titleChangedSignal.add(function (updatedTitle) {
            self.panelTitle(updatedTitle);
        });

        self.componentName = params.componentName;
        self.componentParams = params.componentParams || {};

        _.set(self.componentParams, 'signals.showOptions', showOptionsSignal);
        _.set(self.componentParams, 'signals.showLoadingIcon', self.showLoadingIconSignal);
        _.set(self.componentParams, 'signals.titleChanged', self.titleChangedSignal);

        self.panelOptionsUpdatedSignal = _.get(self.componentParams, 'signals.panelOptionsUpdated');
        self.panelOptionsUpdatedSignal.add(options => {
          if (options.id === self.panelId()) {
            self.componentParams.options = Object.assign({}, self.componentParams.options, options.params.options);
          }
        })

        self.panelId = ko.observable(params.id);
        self.panelTitle = ko.observable(_.get(params, 'componentParams.options.title'));
        self.panelType = ko.observable(params.componentName);  // the component name is also the panel type

        _.set(self.componentParams, 'panelId', self.panelId);

        self.panelDeletedSignal = _.get(self.componentParams, 'signals.panelDeleted');
        self.clonePanelSignal = _.get(self.componentParams, 'signals.clonePanel');
        self.movePanelSignal = _.get(self.componentParams, 'signals.movePanel');
        self.copyPanelSignal = _.get(self.componentParams, 'signals.copyPanel');
        self.copyPanelAdvancedSignal = _.get(self.componentParams, 'signals.copyPanelAdvanced');

        self.showLoadingIcon = ko.observable(true);

        self.subscriptions = [
            self.panelTitle.subscribe(self.titleChanged, self)
        ];
    }

    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    dispose() {
        var self = this;
        self.panelHeaderSignals.deleteButtonClicked.dispose();
        self.panelHeaderSignals.optionsButtonClicked.dispose();
        self.showLoadingIconSignal.dispose();

        _.forEach(self.subscriptions, function (subscription) {
            subscription.dispose();
        });
    }

    onDeleteButtonClicked(panelId) {
        var self = this;
        if (_.isFunction(_.get(self.panelDeletedSignal, 'dispatch'))) {
            self.panelDeletedSignal.dispatch(panelId);
        }
    }

    onClonePanelClicked(panelId) {
      let self = this;
      if (_.isFunction(_.get(self.clonePanelSignal, 'dispatch'))) {
        let optionsSet = {
          panel: PanelOptionsService.getPanelOptions(self.componentParams.options),
          params: self.componentParams.options
        }
        self.clonePanelSignal.dispatch(optionsSet);
      }
    }

    onMovePanelClicked(panelId, tab) {
      let self = this;
      if (_.isFunction(_.get(self.movePanelSignal, 'dispatch'))) {
        let optionsSet = {
          panel: PanelOptionsService.getPanelOptions(self.componentParams.options),
          params: self.componentParams.options
        }
        self.movePanelSignal.dispatch(optionsSet, panelId, tab);
      }
    }

    onCopyPanelClicked() {
      let self = this;
      self.copyPanelSignal.dispatch();
    }

    onCopyPanelAdvancedClicked() {
      let self = this;
      self.copyPanelAdvancedSignal.dispatch();
    }

    onShowLoadingIcon(showLoading) {
        var self = this;
        self.showLoadingIcon(showLoading);
    }

    titleChanged(newTitle) {
        var self = this;
        // todo we should be able to remove the panelOptionsUpdatedSignal
        self.titleChangedSignal.dispatch(newTitle);
        self.panelOptionsUpdatedSignal.dispatch({
            id: ko.unwrap(self.panelId),
            params: { options : { title: newTitle } },
        });
    }
}

ko.components.register('panel', { template: templateMarkup, viewModel: Panel });
